import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { translate } from "react-i18next";
import { withRouter } from 'react-router-dom';
import infoAndSupportActions from "../actions/infoAndSupportActions";
import "./styles/symptoms.css";
import "./styles/infoAndSupportModern.css";
import {
  InputText,
  Dropdown,
  Loading,
  Valert,
  Vmodal,
  InputAmount,
  VautoComplete,
  DateTimePicker,
} from "../components";
import { Row, Col, FormFeedback } from "reactstrap";
import {
  browserName,
  browserVersion,
  osName,
  osVersion,
  deviceType,
} from "react-device-detect";
import moment from "moment";
import button from "react-bootstrap/lib/Button";

// TODO:
// might be better be able to put this styling to a CSS
var _linkStyle = {
  color: "blue",
};
var _paragraphStyle = {
  textIndent: "30px",
};

/**
 * A Custom Modal View that appears when user clicks on the Agreeement Link
 */
let AgreementModal = (props) => {
  const t = props.t;

  //let _msg = t('agreement.MSG_1') + t('agreement.MSG_2') + t('agreement.MSG_3') + t('agreement.MSG_4');

  return (
    <div className="agreement-popup">
      <article>
        <p
          style={{
            textDecoration: "underline",
            textAlign: "center",
            marginBottom: "15px",
            fontWeight: "700",
            fontSize: "1.25rem",
          }}
        >
          {t("agreement.TITLE")}
        </p>
        <div>
          <p className="forgot-title" style={{ marginBottom: "20px" }}>
            {t("agreement.LEAD")}
          </p>
        </div>
        <p className="paraMessages">{t("agreement.MSG_1")}</p>
        <p className="paraMessages">{t("agreement.MSG_2")}</p>
        <p className="paraHeadears">{t("agreement.MSG_3_TITLE")}</p>
        <p className="paraMessages">{t("agreement.MSG_3")}</p>
        <p className="paraMessages">{t("agreement.MSG_4")}</p>
        <p className="paraMessages">{t("agreement.MSG_5")}</p>
        <p className="paraHeadears">{t("agreement.MSG_6_TITLE")}</p>
        <p className="paraMessages">{t("agreement.MSG_7")}</p>
        <p className="paraHeadears">{t("agreement.MSG_8_TITLE")}</p>
        <p className="paraMessages">{t("agreement.MSG_9")}</p>
        <p className="paraHeadears">{t("agreement.MSG_10_TITLE")}</p>
        <p className="paraMessages">{t("agreement.MSG_11")}</p>
        <p className="paraHeadears">{t("agreement.MSG_12_TITLE")}</p>
        <p className="paraMessages">{t("agreement.MSG_13")}</p>
        <p className="paraMessages">{t("agreement.MSG_14")}</p>
        <p className="paraMessages">{t("agreement.MSG_15")}</p>
        <p className="paraMessages">{t("agreement.MSG_16")}</p>
        <div>
          <span style={{ position: "absolute", marginLeft: "20px" }}>1. </span>
          <p className="paraMessages" style={{ marginLeft: "40px" }}>
            {t("agreement.MSG_17")}
          </p>
          <span style={{ position: "absolute", marginLeft: "20px" }}>2. </span>
          <p className="paraMessages" style={{ marginLeft: "40px" }}>
            {t("agreement.MSG_18")}
          </p>
        </div>
        <p className="paraMessages">{t("agreement.MSG_19")}</p>
        <p className="paraHeadears">{t("agreement.MSG_20_TITLE")}</p>
        <p className="paraMessages">{t("agreement.MSG_21")}</p>
        <p className="paraHeadears">{t("agreement.MSG_22_TITLE")}</p>
        <p className="paraMessages">{t("agreement.MSG_23")}</p>
        <p className="paraMessages">{t("agreement.MSG_24")}</p>
        <p className="paraHeadears">{t("agreement.MSG_25_TITLE")}</p>
        <p className="paraMessages">{t("agreement.MSG_26")}</p>
        <p className="paraHeadears">{t("agreement.MSG_27_TITLE")}</p>
        <p className="paraMessages">{t("agreement.MSG_28")}</p>
        <p className="paraHeadears">{t("agreement.MSG_29_TITLE")}</p>
        <p className="paraMessages">{t("agreement.MSG_30")}</p>
        <p className="paraMessages">{t("agreement.MSG_31")}</p>
        <p className="paraMessages">{t("agreement.MSG_32")}</p>
        <p className="paraHeadears">{t("agreement.MSG_33_TITLE")}</p>
        <p className="paraMessages">{t("agreement.MSG_34")}</p>
        <p className="paraMessages" style={{ fontWeight: "bold" }}>
          {t("agreement.MSG_35")}
        </p>

        <br />
      </article>
      <div align="center">
        <a
          className="linkStyle"
          // onClick={() => {
          //   window.location.reload();
          // }}

          onClick={() => {
            try {
              // Next load should start at the top
              sessionStorage.setItem('resetScrollOnce', '1');
              if ('scrollRestoration' in window.history) {
                window.history.scrollRestoration = 'manual';
              }
              window.scrollTo(0, 0);
            } catch (_) {}
            // Cache-busted replace avoids bfcache restoring old scroll
            const base = window.location.pathname + window.location.search;
            const sep = base.includes('?') ? '&' : '?';
            window.location.replace(base + sep + 'fresh=' + Date.now());
          }}


        >
          {t("agreement.UNDERSTAND")}
        </a>
      </div>
    </div>
  );
};
let PrivacyModal = (props) => {
  const t = props.t;

  //let _msg = t('agreement.MSG_1') + t('agreement.MSG_2') + t('agreement.MSG_3') + t('agreement.MSG_4');

  return (
    <div className="agreement-popup">
      <article>
        <p
          style={{
            textDecoration: "underline",
            textAlign: "center",
            fontWeight: "700",
            fontSize: "1.25rem",
            marginBottom: "1rem",
          }}
        >
          {t("privacy.TITLE")}
        </p>
        <p className="paraMessages">{t("privacy.MSG_1")}</p>
        <p className="paraMessages">{t("privacy.MSG_2")}</p>
        <p className="paraMessages">{t("privacy.MSG_3")}</p>
        <p className="paraMessages">{t("privacy.MSG_4")}</p>
        <p className="paraHeadears">{t("privacy.MSG_5_TITLE")}</p>
        <p className="paraMessages">{t("privacy.MSG_6")}</p>
        <p className="paraHeadears" style={{ textDecoration: "none" }}>
          {t("privacy.MSG_7_TITLE")}
        </p>
        <p className="paraMessages">{t("privacy.MSG_8")}</p>
        <p className="paraHeadears" style={{ textDecoration: "none" }}>
          {t("privacy.MSG_9_TITLE")}
        </p>
        <p className="paraMessages">{t("privacy.MSG_10")}</p>
        <p className="paraMessages">{t("privacy.MSG_11")}</p>
        <p className="paraMessages">{t("privacy.MSG_12")}</p>
        <p className="paraHeadears" style={{ textDecoration: "none" }}>
          {t("privacy.MSG_13_TITLE")}
        </p>
        <p className="paraMessages">{t("privacy.MSG_14")}</p>
        <p className="paraHeadears" style={{ textDecoration: "none" }}>
          {t("privacy.MSG_15_TITLE")}
        </p>
        <p className="paraMessages">{t("privacy.MSG_16")}</p>
        <p className="paraHeadears" style={{ textDecoration: "none" }}>
          {t("privacy.MSG_17_TITLE")}
        </p>
        <p className="paraMessages">{t("privacy.MSG_18")}</p>
        <p className="paraHeadears" style={{ textDecoration: "none" }}>
          {t("privacy.MSG_19_TITLE")}
        </p>
        <p className="paraMessages">{t("privacy.MSG_20")}</p>
        <p className="paraHeadears">{t("privacy.MSG_21_TITLE")}</p>
        <p className="paraMessages">
          <span style={{ fontWeight: "bold" }}>{t("privacy.MSG_106")}</span>
          {t("privacy.MSG_22")}
        </p>
        <ul
          style={{
            listStyleType: "disc",
            marginLeft: "20px",
            marginBottom: "20px",
            textAlign: "justify",
          }}
        >
          <li className="paraMessages" style={{ marginBottom: "10px" }}>
            <span style={{ fontWeight: "bold" }}>{t("privacy.MSG_23")}</span>{" "}
            {t("privacy.MSG_24")}
          </li>
          <li className="paraMessages" style={{ marginBottom: "10px" }}>
            <span style={{ fontWeight: "bold" }}>{t("privacy.MSG_25")}</span>{" "}
            {t("privacy.MSG_26")}
          </li>
          <li className="paraMessages">
            <span style={{ fontWeight: "bold" }}>{t("privacy.MSG_27")}</span>{" "}
            {t("privacy.MSG_28")}
          </li>
        </ul>
        <p className="paraMessages">
          <span style={{ fontWeight: "bold" }}>{t("privacy.MSG_29")}</span>{" "}
          {t("privacy.MSG_30")}
        </p>
        <p className="paraMessages">
          <span style={{ fontWeight: "bold" }}>{t("privacy.MSG_31")}</span>{" "}
          {t("privacy.MSG_32")}
        </p>
        <p className="paraHeadears" style={{ textDecoration: "none" }}>
          {t("privacy.MSG_33_TITLE")}
        </p>
        <p className="paraMessages">{t("privacy.MSG_34")}</p>
        <ul
          style={{
            listStyleType: "disc",
            marginLeft: "20px",
            marginBottom: "20px",
            textAlign: "justify",
          }}
        >
          <li className="paraMessages" style={{ marginBottom: "10px" }}>
            <span style={{ fontWeight: "bold" }}>{t("privacy.MSG_35")}</span>{" "}
            {t("privacy.MSG_36")}
          </li>
          <li className="paraMessages" style={{ marginBottom: "10px" }}>
            <span style={{ fontWeight: "bold" }}>{t("privacy.MSG_37")}</span>{" "}
            {t("privacy.MSG_38")}
          </li>
          <li className="paraMessages" style={{ marginBottom: "10px" }}>
            <span style={{ fontWeight: "bold" }}>{t("privacy.MSG_39")}</span>{" "}
            {t("privacy.MSG_40")}
          </li>
          <li className="paraMessages">
            <span style={{ fontWeight: "bold" }}>{t("privacy.MSG_41")}</span>{" "}
            {t("privacy.MSG_42")}
          </li>
        </ul>
        <p className="paraMessages">{t("privacy.MSG_43")}</p>
        <p className="paraHeadears" style={{ textDecoration: "none" }}>
          {t("privacy.MSG_44_TITLE")}
        </p>
        <p className="paraMessages">{t("privacy.MSG_45")}</p>
        <p className="paraMessages">{t("privacy.MSG_46")}</p>
        <p className="paraMessages">{t("privacy.MSG_47")}</p>
        <p className="paraMessages">{t("privacy.MSG_48")}</p>
        <p className="paraHeadears" style={{ textDecoration: "none" }}>
          {t("privacy.MSG_49_TITLE")}
        </p>
        <p className="paraMessages">{t("privacy.MSG_50")}</p>
        <p className="paraMessages">{t("privacy.MSG_51")}</p>
        <p className="paraMessages">{t("privacy.MSG_52")}</p>
        <p className="paraHeadears">{t("privacy.MSG_53_TITLE")}</p>
        <p className="paraMessages">{t("privacy.MSG_107")}</p>
        <ul
          style={{
            listStyleType: "disc",
            marginLeft: "20px",
            marginBottom: "20px",
            textAlign: "justify",
          }}
        >
          <li className="paraMessages">{t("privacy.MSG_54")}</li>
          <li className="paraMessages">{t("privacy.MSG_55")}</li>
          <li className="paraMessages">{t("privacy.MSG_56")}</li>
          <li className="paraMessages">{t("privacy.MSG_57")}</li>
          <li className="paraMessages">{t("privacy.MSG_58")}</li>
          <li className="paraMessages">{t("privacy.MSG_59")}</li>
          <li className="paraMessages">{t("privacy.MSG_60")}</li>
          <li className="paraMessages">{t("privacy.MSG_61")}</li>
          <li className="paraMessages">{t("privacy.MSG_62")}</li>
          <li className="paraMessages">{t("privacy.MSG_63")}</li>
          <li className="paraMessages">{t("privacy.MSG_64")}</li>
        </ul>
        <p className="paraMessages">{t("privacy.MSG_65")}</p>
        <p className="paraMessages">{t("privacy.MSG_66")}</p>
        <p className="paraMessages">{t("privacy.MSG_67")}</p>
        <p className="paraHeadears">{t("privacy.MSG_68_TITLE")}</p>
        <p className="paraHeadears" style={{ textDecoration: "none" }}>
          {t("privacy.MSG_69_TITLE")}
        </p>
        <p className="paraMessages">
          {t("privacy.MSG_70")}

          <span style={{ textDecoration: "underline" }}>
            {t("privacy.MSG_102_TITLE")}
          </span>

          {t("privacy.MSG_104")}
        </p>
        <p className="paraHeadears" style={{ textDecoration: "none" }}>
          {t("privacy.MSG_71_TITLE")}
        </p>
        <p className="paraMessages">{t("privacy.MSG_72")}</p>
        <p className="paraHeadears" style={{ textDecoration: "none" }}>
          {t("privacy.MSG_73_TITLE")}
        </p>
        <p className="paraMessages">{t("privacy.MSG_74")}</p>
        <p className="paraMessages">{t("privacy.MSG_75")}</p>
        <p className="paraHeadears" style={{ textDecoration: "none" }}>
          {t("privacy.MSG_76_TITLE")}
        </p>
        <p className="paraMessages">{t("privacy.MSG_77")}</p>
        <p className="paraHeadears" style={{ textDecoration: "none" }}>
          {t("privacy.MSG_78_TITLE")}
        </p>
        <p className="paraMessages">{t("privacy.MSG_79")}</p>
        <p className="paraMessages">{t("privacy.MSG_80")}</p>
        <p className="paraMessages">
          {t("privacy.MSG_81")}
          <span style={{ textDecoration: "underline" }}>
            {t("privacy.MSG_82_TITLE")}
          </span>

          {t("privacy.MSG_105")}
        </p>
        <p className="paraHeadears">{t("privacy.MSG_82_TITLE")}</p>
        <p className="paraHeadears" style={{ textDecoration: "none" }}>
          {t("privacy.MSG_83_TITLE")}
        </p>
        <p className="paraMessages">{t("privacy.MSG_84")}</p>
        <p className="paraMessages">{t("privacy.MSG_85")}</p>
        <p className="paraMessages">{t("privacy.MSG_86")}</p>
        <p className="paraHeadears" style={{ textDecoration: "none" }}>
          {t("privacy.MSG_87_TITLE")}
        </p>
        <p className="paraMessages">{t("privacy.MSG_88")}</p>
        <p className="paraMessages">{t("privacy.MSG_89")}</p>
        <p className="paraMessages">{t("privacy.MSG_90")}</p>
        <p className="paraHeadears">{t("privacy.MSG_91_TITLE")}</p>
        <p className="paraMessages">{t("privacy.MSG_92")}</p>
        <p className="paraHeadears">{t("privacy.MSG_93_TITLE")}</p>
        <p className="paraMessages">{t("privacy.MSG_94")}</p>
        <p className="paraHeadears">{t("privacy.MSG_95_TITLE")}</p>
        <p className="paraMessages">{t("privacy.MSG_96")}</p>
        <p className="paraMessages">
          {t("privacy.MSG_97")}

          <span style={{ textDecoration: "underline" }}>
            {t("privacy.MSG_100_TITLE")}
          </span>

          {t("privacy.MSG_108")}
        </p>
        <p className="paraMessages">{t("privacy.MSG_98")}</p>
        <p className="paraMessages">{t("privacy.MSG_99")}</p>
        <p className="paraHeadears">{t("privacy.MSG_100_TITLE")}</p>
        <p className="paraMessages">{t("privacy.MSG_101")}</p>
        <p className="paraHeadears">{t("privacy.MSG_102_TITLE")}</p>
        <p className="paraMessages">{t("privacy.MSG_103")}</p>

        <br />
      </article>
      <div align="center">
        <a
          className="linkStyle"
          // onClick={() => {
          //   window.location.reload();
          // }}

          onClick={() => {
            try {
              // Next load should start at the top
              sessionStorage.setItem('resetScrollOnce', '1');
              if ('scrollRestoration' in window.history) {
                window.history.scrollRestoration = 'manual';
              }
              window.scrollTo(0, 0);
            } catch (_) {}
            // Cache-busted replace avoids bfcache restoring old scroll
            const base = window.location.pathname + window.location.search;
            const sep = base.includes('?') ? '&' : '?';
            window.location.replace(base + sep + 'fresh=' + Date.now());
          }}


        >
          {t("agreement.UNDERSTAND")}
        </a>
      </div>
    </div>
  );
};

class InfoAndSupport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showAgreement: "",
      showTrans: false,
      isFaq: true,
      showFaqDialog: false,
      showDirtyModal: false,
      clickOption: "",
      prevBody: "",
    };
  }

  async componentDidMount() {
    try {
      // Stop Firefox/Chrome from restoring previous scroll on reload
      if ('scrollRestoration' in window.history) {
        window.history.scrollRestoration = 'manual';
      }
      // If we reloaded from the policy modal, force to top once
      if (sessionStorage.getItem('resetScrollOnce') === '1') {
        window.scrollTo(0, 0);
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
        sessionStorage.removeItem('resetScrollOnce');
      }
      // Also handle back/forward cache restores
      window.addEventListener('pageshow', (e) => {
        if (e && e.persisted) window.scrollTo(0, 0);
      });
    } catch (_) {}

    const { location, history } = this.props;
    const queryParams = new URLSearchParams(location.search);
    const topic = queryParams.get('topic'); // Replace 'myParam' with your parameter name
    const topicSelect = localStorage.getItem("infoAndSupport");
    await this.props.initialize();
    const height = this.divElement.clientHeight;
    this.setState({ height });
    if (topic) {
      this.props.onChangeForm(topic, "topic");
      this.setState({ prevBody: this.props.theDraft[topic] })
      localStorage.removeItem("infoAndSupport");
      queryParams.delete('topic'); // Replace 'myParam' with your parameter name
      // Update the URL without reloading the page
      history.replace({
        pathname: location.pathname,
        search: queryParams.toString(),
      });
    } else if (topicSelect) {
      this.props.onChangeForm(topicSelect, "topic");
      localStorage.removeItem("infoAndSupport");
    }

  }

  componentWillUnmount() {
    if (!this.props.draft) {
      this.props.resetPage();
    } else {
    }
  }
  handleSubmit() {
    let feed = {
      topic: this.props.feedbackForm.topic,
      version: "1.0",
      device: "Web-" + browserName + "(" + browserVersion + ")",
      device_os_version: osName + " (" + osVersion + ") On " + deviceType,
      desc: this.props.feedbackForm.body,
    };
    this.props.feedbackSubmit(feed);

    setTimeout(() => {
      this.props.resetPage();
    }, 1200);
  }
  handleClear() {
    this.noIdValert.changeStatus();
  }
  getType(val) {
    let typeList = [
      { value: 100, label: this.props.t("support.CONTRIBUTED_ITEM_TEXT") },
      { value: 101, label: this.props.t("support.GRAPH_REPORT_TEXT") },
      { value: 102, label: this.props.t("support.GRAPH_DATA_REPORT_TEXT") },
      { value: 103, label: this.props.t("support.TRIGGER_AND_RATING_TEXT") },
      { value: 104, label: this.props.t("support.PURCHASED_TEXT") },
    ];
    let type = "";
    typeList.map((item) => {
      if (val === item.value) {
        type = item.label;
      }
    });
    return type;
  }
  handleToggle(e, type) {
    if (type) {
      const modal =
        type === "agreement"
          ? <AgreementModal t={this.props.t} clicked={this.handleToggle} />
          : <PrivacyModal t={this.props.t} clicked={this.handleToggle} />;

      this.setState({ showAgreement: modal }, () => {
        // Reset page scroll so the modal starts at the top (Firefox fix)
        try {
          const se = document.scrollingElement || document.documentElement;
          se.scrollTop = 0;
          // belt & suspenders for older engines:
          document.body.scrollTop = 0;
        } catch(_) { /* no-op */ }
      });
    }
  }

  handleBuyMore() {
    this.buyMoreClicked.changeStatus();
  }

  render() {
    const {
      t,
      isLoading,
      onChangeForm,
      feedbackForm,
      draftBtn,
      creditAmount,
      transActions,
    } = this.props;

    const { prevBody } = this.state;
    let feedbackData = [
      {
        label: t("support.SELECT_TOPIC_PLACEHOLDER"),
        value: "null",
      },
      {
        label: t("support.BUG_DROPDOWN_OPTION"),
        value: "softwarebug",
      },
      {
        label: t("support.USABILITY_DROPDOWN_OPTION"),
        value: "usability",
      },
      {
        label: t("support.FEEDBACK_DROPDOWN_OPTION"),
        value: "feedback",
      },
      {
        label: t("support.HELP_DROPDOWN_OPTION"),
        value: "help",
      },
      {
        label: t("support.CREDIT_BALANCE_TEXT"),
        value: "creditBalance",
      },
      {
        label: t("general.OTHER_GENDER_TEXT"),
        value: "other",
      },
    ];
    const faqs = t("faq.items", {
      returnObjects: true,
    });
    const handleClicks = () => {
      // localStorage.removeItem("unsavedAlertData");
      if (this.state.clickOption === "PP") {
        this.handleToggle("pp", "privacy");
      } else if (this.state.clickOption === "TC") {
        this.handleToggle("tc", "agreement");
      } else if (this.state.clickOption === "CB") {
        this.props.tansActionsList();
        this.setState({ showTrans: true });
      }
      this.props.clearDirtyDraft();
      this.setState({ clickOption: "", showDirtyModal: false });
    };


    return (
      <div>
        <div className="vPage symptom flex info-support-modern">
          {this.state.activeTopic}
          {this.state.showAgreement}
          <Loading isLoading={isLoading} />
          <Vmodal
            displayStatus={this.props.darftSaved}
            data={
              this.props.draft ? (
                <div>
                  <h4>Draft Updated Successfully</h4>
                  <p>Your draft has been updated.</p>
                </div>
              ) : (
                <div>
                  <h4>{t("forum.SAVE_DRAFT_TITLE")}</h4>
                  <p>{t("forum.SAVE_DRAFT_TEXT")}</p>
                </div>
              )
            }
            closeFunc={() => {
              window.location.reload();
            }}
            timedClose={2000}
          />
          <Vmodal
            displayStatus={this.props.isDirty && this.state.showDirtyModal}
            data={
              <div>
                <h4>{t("support.SAVED_DRAFT_DATA_TITLE")}</h4>
                <p>{t("support.SAVED_DRAFT_DATA_TEXT")}</p>
              </div>
            }
            closeFunc={handleClicks}
            timedClose={2000}
          />
          <Vmodal
            displayStatus={this.state.showFaqDialog}
            zIndex="99"
            containerStyle={{ maxWidth: "70%" }}
            data={
              <div
                className="d-flex flex-column justify-content-end align-items-end"
                style={{
                  maxHeight: "80vh",
                }}
              >
                <div
                  className="align-self-start"
                  style={{
                    fontWeight: "bold",
                    textAlign: "left",
                    paddingBottom: 8,
                    paddingTop: 8,
                    paddingLeft: 22,
                    fontSize: 22,
                    marginBottom: 8,
                  }}
                >
                  {t("faq.TITLE")}
                </div>
                <div
                  style={{
                    overflowY: "scroll",
                    maxHeight: "100%",
                    color: "black",
                  }}
                >
                  <div className="w-100 d-flex flex-column">
                    {faqs.map((item) => (
                      <div>
                        <b style={{ color: "black" }}>{item.title}</b>
                        <p
                          style={{ color: "black", whiteSpace: "pre-line" }}
                          dangerouslySetInnerHTML={{ __html: item.body }}
                        />
                      </div>
                    ))}
                  </div>
                </div>
                <button
                  className="btn btn-primary mt-4 px-4"
                  onClick={() =>
                    this.setState((prev) => ({
                      ...prev,
                      showFaqDialog: false,
                    }))
                  }
                >
                  {t("general.OK_PROMPT_TEXT")}
                </button>
              </div>
            }
          />
          <Valert
            display={false}
            title={t("support.BUY_MORE_POINTS_TITLE")}
            question={t("support.BUY_MORE_POINTS_TEXT")}
            onRef={(ref) => (this.buyMoreClicked = ref)}
            positiveText={t("support.FREE_POINTS_BUTTON")}
            positiveAction={() => {
              window.location.href = "/contribute";
            }}
          />
          <Valert
            display={false}
            title={t("general.CLEAR_CONFIRMATION_TITLE")}
            question={t("support.INFO_AND_SUPPORT_CLEAR_TEXT")}
            onRef={(ref) => (this.noIdValert = ref)}
            positiveText={t("general.POSITIVE_PROMPT_TEXT")}
            positiveAction={() => {
              this.props.resetPage("clearTopic");
            }}
          />
          <Valert
            display={this.props.submit}
            title={t("support.SEND_SUCCESSFULLY_TITLE")}
            question={t("support.INFO_AND_SUPPORT_SUBMIT_TEXT")}
            onRef={(ref) => (this.submitSuccess = ref)}
            positiveText={t("general.OK_PROMPT_TEXT")}
            readOnly={true}
          />
          <div
            className={`grayList `}
            style={{
              padding: "1rem",
              overflow: "hidden",
              marginBottom: "0.5rem",
            }}
          >
            <Row>
              <Col sm="5">
                <div>
                  <p>{t("support.APPLICATION_LABLE_TITLE")}</p>
                  <p>{t("support.VERSION_LABLE_TITLE")}</p>
                  <p>{t("support.PRIVACY_LABLE_TITLE")}</p>
                  <p>{t("support.TERMS_LABEL_TITLE")}</p>
                  <p>{t("support.CREDIT_BALANCE_TEXT")}</p>
                  <p>{t("support.SUPPORT_LABEL_TITLE")}</p>
                </div>
              </Col>
              <Col sm="7">
                <div>
                  <p style={{ paddingLeft: "6px" }}>
                    {t("support.12U12_INFO_TEXT")}
                  </p>
                  <p style={{ paddingLeft: "6px" }}>
                    {"1.0" +
                      // t("support.REDIRECTION_LINK_TEXT")

                      " " +
                      t("support.FREE_EDITION_INFO_TEXT")}
                  </p>
                  <p style={{ paddingLeft: "6px" }}>
                    <a
                      className="linkStyle"
                      onClick={(e) => {
                        if (this.props.isDirty) {
                          this.setState({
                            showDirtyModal: true,
                            clickOption: "PP",
                          });
                        } else {
                          this.handleToggle(e, "privacy");
                        }
                      }}
                    >
                      {t("support.CLICK_HERE_LINK_TEXT")}
                    </a>
                  </p>
                  <p style={{ paddingLeft: "6px" }}>
                    <a
                      className="linkStyle"
                      onClick={(e) => {
                        if (this.props.isDirty) {
                          this.setState({
                            showDirtyModal: true,
                            clickOption: "TC",
                          });
                        } else {
                          this.handleToggle(e, "agreement");
                        }
                      }}
                    >
                      {t("support.CLICK_HERE_LINK_TEXT")}
                    </a>
                  </p>
                  <p style={{ paddingLeft: "6px" }}>
                    {creditAmount}
                    {t("support.POINTS_TEXT")}
                    {" ("}
                    <a
                      className="linkStyle"
                      onClick={() => {
                        if (this.props.isDirty) {
                          this.setState({
                            showDirtyModal: true,
                            clickOption: "CB",
                          });
                        } else {
                          this.props.tansActionsList();
                          this.setState({ showTrans: true });
                        }
                      }}
                    >
                      {t("support.CLICK_HERE_LINK_TEXT")}
                    </a>
                    <span>{t("support.FOR_DETAILS_TEXT")}</span>
                    {")"}
                  </p>
                  <Row style={{ paddingRight: "8rem" }}>
                    <div
                      style={{
                        borderRadius: 4,
                        border: `0.5px solid #ced4da`,
                        minWidth: "100%",
                      }}
                    >
                      <select
                        className="form-control basic-white-dropdown"
                        onChange={(e) => {
                          setTimeout(() => {
                            this.setState({
                              showTrans: false,
                              prevBody: feedbackForm.body,
                            });
                          }, 100);
                          onChangeForm(e.target.value, "topic");

                          if (this.props.isDirty) {
                            this.setState({
                              showDirtyModal: true,
                            });
                          } else {
                            this.props.clearDirtyDraft();
                          }
                        }}
                        value={
                          this.props.feedbackForm &&
                          this.props.feedbackForm.topic
                        }
                      >
                        {feedbackData &&
                          feedbackData.map((feed) => {
                            return (
                              <option value={feed.value}>{feed.label}</option>
                            );
                          })}
                      </select>
                    </div>
                  </Row>
                </div>
              </Col>
            </Row>
          </div>
          <div
            ref={(divElement) => {
              this.divElement = divElement;
            }}
            className="form-group d-flex"
            style={{ flexGrow: 1 }}
          >
            {this.state.showTrans ? (
              <div
                className="grayList"
                style={{
                  flex: 1,
                  padding: 30,
                  height: this.state.height,
                  overflowY: "auto",
                }}
              >
                <Row
                  style={{
                    color: "#212529",
                    paddingBottom: 5,
                    marginBottom: 10,
                    borderBottom: "1px solid #e1e1e1",
                  }}
                >
                  <Col xs={3}>{t("meal_planner.DATE_TEXT")}</Col>
                  <Col xs={7}>{t("support.DESCRIPTION_TEXT")}</Col>
                  <Col xs={2}>{t("general.ITEM_VALUE_TEXT")}</Col>
                </Row>
                {transActions && transActions.length > 0
                  ? transActions.map((item) => {
                    return (
                      <Row
                        style={{
                          color: "#8f8f8f",
                          marginBottom: 6,
                          fontSize: "0.8rem",
                        }}
                      >
                        <Col xs={3}>
                          {moment.unix(item.date).format("MM/DD/YY")}
                        </Col>
                        <Col xs={7}>{this.getType(item.type)}</Col>
                        <Col
                          xs={2}
                          style={{
                            textAlign: "right",
                            marginLeft: "-22px",
                          }}
                        >
                          {item.amount}
                          {item.amount == 1 || item.amount == -1
                            ? t("support.POINT_TEXT")
                            : t("support.POINT_TEXT")}
                        </Col>
                      </Row>
                    );
                  })
                  : !isLoading && (
                    <Row
                      style={{
                        marginBottom: 6,
                        fontSize: "0.8rem",
                        color: "#8f8f8f",
                      }}
                    >
                      <Col xs={3}>
                        <div style={{ paddingLeft: 12 }}>-</div>
                      </Col>
                      <Col xs={7}>{t("general.NO_TRANSACTIONS")}</Col>
                      <Col xs={2} className="text-center">
                        <div style={{ paddingRight: 12 }}>0</div>
                      </Col>
                    </Row>
                  )}
              </div>
            ) : (
              <InputText
                type="textarea"
                placeholder={t("support.TEXTAREA_PLACEHOLDER_TEXT")}
                disabled={
                  feedbackForm &&
                    feedbackForm.topic &&
                    feedbackForm.topic != "null"
                    ? false
                    : true
                }
                input={{
                  onChange: (e) =>
                    onChangeForm(e.target.value, "body", prevBody),
                  name: "body",
                  value: feedbackForm && feedbackForm.body,
                }}
                style={{ height: "100%", width: "100%" }}
                meta={{}}
                wrapperStyle={{ width: "100%" }}
                maxLength={5000}
              />
            )}
          </div>
          <div className="row formRow">
            <div className="col">
              {this.state.isFaq && !this.state.showTrans ? (
                <button
                  type="button"
                  className="btn btn-primary btnWide"
                  onClick={() =>
                    this.setState((prev) => ({ ...prev, showFaqDialog: true }))
                  }
                >
                  {t("forum.FAQ_BUTTON")}
                </button>
              ) : (
                <button
                  type="button"
                  className="btn btn-primary btnWide"
                  onClick={() => this.handleBuyMore()}
                >
                  {t("support.BUY_MORE_TITLE")}
                </button>
              )}
            </div>
            <div className="col">
              <button
                className="btn btn-primary btnWide"
                disabled={
                  this.state.showTrans ||
                    (feedbackForm &&
                      feedbackForm.topic &&
                      feedbackForm.topic != "null" &&
                      feedbackForm.body &&
                      feedbackForm.body.length > 0)
                    ? false
                    : true
                }
                onClick={() => {
                  this.state.showTrans
                    ? (window.location.href = "/contribute")
                    : this.handleSubmit();
                }}
              >
                {this.state.showTrans
                  ? t("support.GET_FREE_POINTS_TEXT")
                  : t("general.SUBMIT")}
              </button>
            </div>
            <div className="col">
              <button
                type="button"
                className="btn btn-primary btnWide"
                onClick={() => {
                  this.state.showTrans
                    ? (this.props.onChangeForm("creditBalance", "topic", this.props.theDraft['creditBalance']),
                      this.setState({
                        showTrans: false,
                        prevBody: this.props.theDraft['creditBalance']
                      }))
                    : this.handleClear();
                }}
                disabled={
                  this.state.showTrans ||
                    (feedbackForm &&
                      feedbackForm.topic &&
                      feedbackForm.topic != "null" &&
                      feedbackForm.body &&
                      feedbackForm.body.length > 0)
                    ? false
                    : true
                }
              >
                {this.state.showTrans
                  ? t("support.CONTACT_US_TEXT")
                  : t("general.CLEAR_PAGE_BUTTON")}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

InfoAndSupport = translate("translations")(InfoAndSupport);

const mapStateToProps = (state) => ({
  ...state.support,
});

const matchDispatchToProps = (dispatch) =>
  bindActionCreators({ ...infoAndSupportActions }, dispatch);

export default connect(mapStateToProps, matchDispatchToProps)(InfoAndSupport);



// WEBPACK FOOTER //
// ./src/pages/InfoAndSupport.js